import { render, staticRenderFns } from "./new-entry-link.vue?vue&type=template&id=5a0d2183"
import script from "./new-entry-link.vue?vue&type=script&lang=js"
export * from "./new-entry-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports